<app-side-menu>
  <div class="customers-content">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="statusFilter" class="form-label">Status</label>
          <select
            id="statusFilter"
            class="form-select"
            [(ngModel)]="filters.status"
            (change)="onFiltersChange()">
            <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="filter-group">
          <label for="categoryFilter" class="form-label">Categoria</label>
          <select
            id="categoryFilter"
            class="form-select"
            [(ngModel)]="filters.category"
            (change)="onFiltersChange()">
            <option *ngFor="let opt of categoryOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>

        <div class="filter-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
          <button type="button" class="btn btn-success" (click)="openExportModal()">
            <i class="fas fa-file-excel me-2"></i>
            Exportar Excel
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="customers-card">
          <!-- Loading -->
          <!-- Tabela sempre visível (header com busca sempre aparece) -->
          <div class="customers-table" *ngIf="isLoading || (customers && customers.length > 0) || filters.status || filters.category || filters.searchTerm">
            <div class="table-content">
              <app-table
                [title]="tableTitle"
                [data]="filteredCustomers"
                [columns]="columns"
                [loading]="isLoading"
                [showSearch]="showSearch"
                [searchPlaceholder]="searchPlaceholder"
                [clickable]="clickable"
                [actions]="actions"
                [disablePagination]="false"
                [itemsPerPage]="pageSize"
                [totalItemsFromBackend]="totalCustomers"
                [hasNextPageFromBackend]="hasNextPage"
                [hasPreviousPageFromBackend]="hasPreviousPage"
                [currentPageFromBackend]="currentPage"
                [enableSorting]="true"
                [sortableColumns]="['name', 'email', 'customerCategory']"
                (rowClick)="view($event)"
                (actionClick)="onActionClick($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)"
                (searchChange)="onSearchChange($event)"
                (sortChange)="onSortChange($event)">
                <app-button
                  *appHasPermission="'Customers.Create'"
                  table-header-action
                  text="Novo Cliente"
                  [color]="'var(--primary-light)'"
                  [height]="'42px'"
                  className="new-customer-btn"
                  (buttonClick)="newCustomer()">
                </app-button>
              </app-table>
            </div>
          </div>

          <!-- Mensagem quando não há resultados (apenas quando não está carregando) -->
          <div *ngIf="!isLoading && (!customers || customers.length === 0)" class="empty-state" style="margin-top: 20px;">
            <i class="fas fa-user-group"></i>
            <h3>Nenhum cliente encontrado</h3>
            <p *ngIf="hasActiveFilters()">
              Nenhum cliente corresponde aos filtros aplicados. Tente ajustar os filtros ou limpar a busca.
            </p>
            <p *ngIf="!hasActiveFilters()">
              Comece cadastrando seu primeiro cliente para gerenciar seu relacionamento comercial.
            </p>
            <app-button
              *appHasPermission="'Customers.Create'"
              text="Cadastrar Primeiro Cliente"
              color="var(--primary-light)"
              (buttonClick)="newCustomer()"
              className="btn-primary">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>

<!-- Modal Exportar Excel -->
<app-modal
  [isOpen]="showExportModal"
  [title]="'Exportar clientes para Excel'"
  [size]="'lg'"
  [closable]="true"
  (close)="closeExportModal()">

  <div class="report-form">
    <div class="report-section mb-4">
      <h5 class="section-title">
        <i class="fas fa-list-check me-2"></i>
        Colunas do relatório
      </h5>
      <p class="text-muted small mb-3">Selecione as colunas que deseja incluir na planilha</p>

      <div *ngIf="loadingExportColumns" class="mb-3">
        <i class="fas fa-spinner fa-spin me-2"></i>
        Carregando colunas...
      </div>

      <div class="field-actions mb-3" *ngIf="!loadingExportColumns && availableExportColumns.length">
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="selectAllExportFields()">
          <i class="fas fa-check-double me-1"></i>
          Selecionar todas
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="deselectAllExportFields()">
          <i class="fas fa-times me-1"></i>
          Desmarcar todas
        </button>
      </div>

      <div class="fields-grid" *ngIf="!loadingExportColumns">
        <div *ngFor="let field of availableExportColumns" class="field-checkbox">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              [id]="'export-field-' + field.key"
              [checked]="field.checked"
              (change)="toggleExportField(field.key)">
            <label class="form-check-label" [for]="'export-field-' + field.key">
              {{ field.label }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="report-section mb-4">
      <h5 class="section-title">
        <i class="fas fa-filter me-2"></i>
        Filtros (opcional)
      </h5>
      <p class="text-muted small mb-3">Os mesmos filtros podem ser aplicados na exportação</p>

      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label">Status</label>
          <select
            class="form-control form-select"
            [(ngModel)]="exportFilters.status">
            <option [ngValue]="null">Todos</option>
            <option *ngFor="let opt of statusOptions" [ngValue]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Categoria</label>
          <select
            class="form-control form-select"
            [(ngModel)]="exportFilters.category">
            <option [ngValue]="null">Todas</option>
            <option *ngFor="let opt of categoryOptions" [ngValue]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Busca (termo)</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="exportFilters.searchTerm"
            placeholder="Nome, documento, e-mail...">
        </div>
      </div>
    </div>

    <div *ngIf="exportError" class="alert alert-danger">
      <i class="fas fa-exclamation-triangle me-2"></i>
      {{ exportError }}
    </div>
  </div>

  <div slot="footer" class="modal-footer-buttons">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="closeExportModal()"
      [disabled]="isExporting">
      Cancelar
    </button>
    <button
      type="button"
      class="btn btn-success"
      (click)="generateExport()"
      [disabled]="isExporting">
      <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2"></span>
      <i *ngIf="!isExporting" class="fas fa-file-excel me-2"></i>
      {{ isExporting ? 'Exportando...' : 'Exportar Excel' }}
    </button>
  </div>
</app-modal>
